@if (multipleSelect) {
<input
    class="option option--checkbox"
    type="checkbox"
    [id]="'option-' + groupId + '-' + id"
    [value]="groupId + '-' + id"
    [name]="groupId + '-' + id"
    #formControl
/>
} @else {
<input
    class="option option--radio"
    type="radio"
    [id]="'option-' + groupId + '-' + id"
    [value]="id"
    [name]="groupId"
    #formControl
/>
}

<label
    class="label"
    [ngClass]="{
        'label--correct': answerState === answerStateEnum.Correct,
        'label--incorrect': answerState === answerStateEnum.InCorrect
    }"
>
    <i class="checkmark far"></i>

    <ng-content></ng-content>
    <app-state-icon [state]="answerState"></app-state-icon>
</label>
